import React, { useEffect, useState } from "react";
import { Translator } from "./translator";

const NFTconditions = () => {
  const { translateText, lang } = Translator();

  const baseText = {
    title: "Termini e Condizioni NFT",
    updated: "Ultimo aggiornamento: 1 Luglio 2025",
    intro: "Questi Termini e Condizioni regolano l'accesso e l'uso delle sezioni NFT del sito Te.C.H-e gestito da Emozionarti srl (“Te.C.H-e,” “noi,” o “nostro”).",

    usageTitle: "Uso degli NFT Visualizzati",
    usageContent: "Te.C.H-e presenta i suoi asset digitali unici (NFTteche) integrati con il marketplace internazionale OpenSea. Gli NFTteche non possono essere copiati, sostituiti o suddivisi. La proprietà di un NFTteche è registrata nella blockchain di OpenSea e può essere trasferita dal proprietario, consentendo la vendita e lo scambio di NFT.",

    ownershipTitle: "Proprietà e Licenze",
    ownershipContent: "Tutti i diritti relativi agli NFT visualizzati, inclusi diritti di proprietà intellettuale e licenze d'uso, sono regolati dai termini di OpenSea e dai rispettivi creatori o titolari. Te.C.H-e detiene diritti di proprietà sugli NFT mostrati tramite il nostro sito.",

    liabilityTitle: "Limitazione di Responsabilità",
    liabilityContent: "Te.C.H-e non è responsabile per eventuali imprecisioni, cambiamenti di disponibilità, violazioni di copyright o diritti di terzi relativi agli NFT mostrati, né per eventuali perdite, danni o controversie derivanti dall'interazione con piattaforme esterne come OpenSea.",

    externalTitle: "Link a Piattaforme Esterne",
    externalContent: "I collegamenti agli NFT reindirizzano a piattaforme esterne come OpenSea. Te.C.H-e non controlla né è responsabile per i contenuti, le transazioni o le politiche di tali piattaforme. L'uso di OpenSea è soggetto ai termini e condizioni di OpenSea stessa.",

    changesTitle: "Modifiche ai Termini",
    changesContent: "Te.C.H-e si riserva il diritto di modificare questi Termini e Condizioni NFT in qualsiasi momento. Eventuali modifiche saranno pubblicate su questa pagina con la data di aggiornamento.",

    contactTitle: "Contatti",
    contactContent: "Per domande o chiarimenti riguardanti gli NFT visualizzati su Te.C.H-e, puoi contattarci a:\nemozionartisrl@gmail.com\n+39 081 424 4274",
  };

  const [translatedText, setTranslatedText] = useState(baseText);

  useEffect(() => {
    const translateAll = async () => {
      const entries = Object.entries(baseText);
      const translated = await Promise.all(
        entries.map(async ([key, val]) => [key, await translateText(val)])
      );
      setTranslatedText(Object.fromEntries(translated));
    };

    translateAll();
  }, [lang]);

  return (
    <div className="px-5 md:px-20 py-10 font-sans text-black max-w-5xl mx-auto">
      <h1 className="text-black text-3xl font-bold mb-4 text-center">{translatedText.title}</h1>
      <p className="mb-4 text-center text-sm text-gray-600">{translatedText.updated}</p>
      <hr className="my-6 border-gray-300" />

      <p className="mb-4 text-center">{translatedText.intro}</p>

      <Section title={translatedText.usageTitle}>{translatedText.usageContent}</Section>
      <Section title={translatedText.ownershipTitle}>{translatedText.ownershipContent}</Section>
      <Section title={translatedText.liabilityTitle}>{translatedText.liabilityContent}</Section>
      <Section title={translatedText.externalTitle}>{translatedText.externalContent}</Section>
      <Section title={translatedText.changesTitle}>{translatedText.changesContent}</Section>

      <section className="mt-10 text-center">
        <h2 className="text-black text-xl font-semibold mb-2">{translatedText.contactTitle}</h2>
        <pre className="whitespace-pre-wrap text-sm text-gray-700">
          {translatedText.contactContent}
        </pre>
      </section>
    </div>
  );
};

const Section = ({ title, children }) => (
  <section className="mt-10 text-center">
    <h2 className="text-black text-xl font-semibold mb-2">{title}</h2>
    <p className="text-base leading-relaxed">{children}</p>
  </section>
);

export default NFTconditions;
